export const StartPCPlay = 'startPCPlay';

// 手机端加入遥控器的事件常量
export const MOBILE_JOIN = 'mobileJoin';
